import { INode } from 'shared/types/tree'
import { Box, Button } from '@mui/material'
import * as React from 'react'
import { useMemo } from 'react'
import { srcsFromString } from '../../ingestion/Utility'
import { CountTable } from '../../utility/CountTable'
import { useGetTreeById } from 'shared/hooks/trees/hooks'
import { useListSwap } from 'shared/hooks'
import { domainCounts } from './utility'
import { ImageUrlCheck } from './ImageUrlCheck'

export function ImageSources({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const { tree } = useGetTreeById({ treeId, versionId })
  return (
    <Box>
      <Box>Image Sources</Box>
      {!tree && <Box>Loading...</Box>}
      {tree && <SourceTable tree={tree} />}
    </Box>
  )
}

function SourceTable({ tree }: { tree: INode }) {
  const imgSrcs = useImageSources(tree)
  const allKeys = useMemo(() => {
    return Object.keys(imgSrcs)
  }, [imgSrcs])
  const { toInclude, toExclude, onInclude, onExclude } = useListSwap({
    items: allKeys,
  })

  const { excludedCols, includedCols } = useMemo(() => {
    return {
      includedCols: [
        {
          title: 'Exclude',
          rowContent(key: string) {
            return <Button onClick={() => onExclude(key)}>Exclude</Button>
          },
          skipExport: true,
        },
      ],
      excludedCols: [
        {
          title: 'Include',
          rowContent(key: string) {
            return <Button onClick={() => onInclude(key)}>Include</Button>
          },
          skipExport: true,
        },
      ],
    }
  }, [onExclude, onInclude])

  const urlsToCheck = useMemo(() => {
    return Object.entries(imgSrcs).reduce<string[]>((acc, [domain, urls]) => {
      if (toExclude.includes(domain) || domain === 'data') return acc
      return [...acc, ...urls]
    }, [])
  }, [imgSrcs, toExclude])

  return (
    <Box>
      <CountTable
        header1={'Domain'}
        data={imgSrcs}
        extraColumns={includedCols}
        filteredKeys={toInclude}
      />
      {!!toExclude.length && (
        <CountTable
          header1={'Excluded'}
          data={imgSrcs}
          extraColumns={excludedCols}
          filteredKeys={toExclude}
        />
      )}
      <ImageUrlCheck toCheck={urlsToCheck} tree={tree} />
    </Box>
  )
}

function useImageSources(tree: INode) {
  return useMemo(() => {
    const urls = srcsFromString(JSON.stringify(tree))
    return domainCounts(urls)
  }, [tree])
}
